"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var Container = exports.Container = _styledComponents["default"].div.withConfig({
  displayName: "styled__Container",
  componentId: "sc-nvzk86-0"
})(["width:700px;border-radius:4px;overflow:hidden;box-shadow:0px 1px 2px rgba(210,208,197,0.9),0px 10px 15px rgba(216,214,204,0.9);"]);